module.exports = __webpack_public_path__ + "static/media/mealcraft.ef8ed7f0.png";